<template>
    <div class="c-row">
        <div class="c-tr">
            <div class="c-td w-name">
                <p class="text-primary typo--lg font-weight-medium mb-2">
                    {{ merchant.name }}
                </p>
                <p class="typo--sm mb-0">
                    ul {{ merchant.street }} {{ merchant.number }}
                    <br />
                    {{ merchant.postcode }} {{ merchant.city }}
                </p>
            </div>
            <div class="c-tw w-middle">
                <div class="c-tw w-stats">
                    <div class="c-td">
                        <span
                            class="
                                typo-label
                                d-inline-block d-sm-block d-lg-none
                                mb-sm-2
                            "
                            >Ostatnia zmiana</span
                        >
                        <span class="d-inline-block typo-number typo--lg">{{
                            $moment(data.updated_at).format('YYYY-MM-DD, HH:mm')
                        }}</span>
                    </div>
                    <!-- TODO : użytkownik -->
                    <!-- <div class="c-td">
                        <span
                            class="typo-label d-inline-block d-sm-block d-lg-none mb-sm-2"
                        >Użytkownik</span>
                        <span class="d-inline-block typo-number typo--lg">Jan Kowalski</span>
                    </div>-->
                    <div class="c-td">
                        <span
                            class="
                                typo-label
                                d-inline-block d-sm-block d-lg-none
                                mb-sm-2
                            "
                            >Status promocji</span
                        >
                        <span
                            v-if="data.state === 'accepted'"
                            class="status is-success"
                        >
                            <a-icon icon="Ok" />
                            <span>Zaakceptowana</span>
                        </span>
                        <span
                            v-if="data.state === 'available'"
                            class="status is-pending"
                        >
                            <span>Dostępna</span>
                        </span>
                        <span
                            v-if="promotionCanceled"
                            class="status is-canceled"
                        >
                            <a-icon icon="Info" />
                            <span>Anulowana</span>
                        </span>
                        <span
                            v-if="data.state === 'incompatible'"
                            class="status is-incompatible"
                        >
                            <tooltip-info
                                :side="'top'"
                                :content="true"
                                :customClass="'bg-dark text-white'"
                                :text="
                                    'Przynajmniej jedna kasa / stanowisko POS w sklepie, nie obsługuje tego typu promocji. Zaktualizuj kasę / system sprzedażowy do najnowszej wersji oprogramowania. Zadzwoń jeśli potrzebujesz wsparcia 22 123 84 00.'
                                "
                            >
                                <a-icon class="text-white" icon="Info" />
                            </tooltip-info>
                            <span>Nieobsługiwana</span>
                        </span>
                        <span
                            v-if="data.state === 'conflict'"
                            class="status is-error"
                            style="cursor: pointer"
                            @click="goToConflictedPromo"
                        >
                            <tooltip-info
                                :side="'top'"
                                :content="true"
                                :customClass="'bg-dark text-white'"
                                :text="
                                    'Co najmniej jeden EAN w obecnie akceptowanej promocji, występuje już w innej, aktywnej promocji w tym sklepie. Kliknij w pole konflikt, aby przejść do oferty powodującej konflikt. Przerwij trwającą promocję jeśli chcesz aktywować nową promocję na ten sam EAN.'
                                "
                            >
                                <a-icon class="text-white" icon="Info" />
                            </tooltip-info>
                            <span>Konflikt</span>
                        </span>
                        <span
                            v-if="data.status === 'cancelled_by_company'"
                            class="status is-error"
                        >
                            <a-icon icon="Info" />
                            <span>Odrzucona</span>
                        </span>
                        <span
                            v-if="data.state === 'archived'"
                            class="status is-canceled"
                        >
                            <a-icon icon="Info" />
                            <span>Zarchiwizowana</span>
                        </span>
                    </div>
                </div>
                <div class="c-tw w-ean text-center">
                    <div class="c-td">
                        <span class="typo-label d-inline d-md-none mb-2"
                            >EAN</span
                        >
                        <product-ean
                            v-for="(product, idx) in data.products.filter(
                                el => el.promotional
                            )"
                            :key="idx"
                            :ean="product.dict_product.ean"
                            :title="product.dict_product.name"
                        ></product-ean>
                        <span
                            v-for="(set, idx) in data.product_sets"
                            class="typo-number"
                            :key="idx"
                            >Zestaw {{ idx + 1 }}</span
                        >
                    </div>
                    <div
                        class="c-td"
                        v-if="
                            promoType !== 'Promo::Supply' &&
                                promoType !== 'Promo::SalesTarget'
                        "
                    >
                        <span class="typo-label d-inline d-md-none mb-2"
                            >Zestaw i cena</span
                        >
                        <template v-if="promoType === 'Promo::Percentage'">
                            <div
                                v-for="(product, idx) in data.products"
                                :key="idx"
                                class="typo-number pr-3"
                            >
                                {{ product.percentage_discount }}%
                            </div>
                        </template>
                        <template v-else>
                            <money-input
                                v-for="(product, idx) in data.products.filter(
                                    el => el.promotional
                                )"
                                :class="{
                                    'mb-1': idx < data.products.length - 1
                                }"
                                :key="idx + data.id"
                                :disabled="
                                    $store.getters.isLotteryUser ||
                                        data.state !== 'available' ||
                                        promoType === 'Promo::Supply' ||
                                        promoType === 'Promo::SalesTarget'
                                "
                                :price="
                                    data.state !== 'accepted' ||
                                    promoType === 'Promo::Supply'
                                        ? +product.maximum_promotional_price
                                        : +data.product_subscriptions.find(
                                              el => el.id === product.id
                                          ).price
                                "
                                :maxValue="+product.maximum_promotional_price"
                                @onChange="
                                    changePriceProduct(
                                        product.id,
                                        $event,
                                        product.maximum_promotional_price,
                                        $event
                                    )
                                "
                            />
                            <money-input
                                v-for="(set, idx) in data.product_sets"
                                :class="{
                                    'mb-1': idx < data.products.length - 1
                                }"
                                :key="idx + data.id"
                                :disabled="
                                    $store.getters.isLotteryUser ||
                                        data.state !== 'available' ||
                                        promoType === 'Promo::Supply'
                                "
                                :price="
                                    data.state !== 'accepted' ||
                                    promoType === 'Promo::MixPromotional'
                                        ? +set.price
                                        : +data.product_set_subscriptions.find(
                                              el => el.product_set_id === set.id
                                          ).price
                                "
                                :maxValue="+set.price"
                                @onChange="
                                    changePriceProductSet(
                                        set.id,
                                        $event,
                                        +set.price,
                                        $event
                                    )
                                "
                            />
                        </template>
                    </div>
                </div>
            </div>
            <div class="c-td w-actions d-flex justify-content-end">
                <div
                    v-tooltip="{
                        content: promotionCanceled
                            ? ' Ponowna aktywacja promocji w tym sklepie będzie możliwa jutro.'
                            : null
                    }"
                    class="tr__checkbox custom-control text-right p-0"
                    style="width: max-content"
                >
                    <ui-checkbox-input
                        large
                        :name="'c-subs-' + data.id"
                        v-model="selectedSubscription"
                        :disabled="data.state !== 'available'"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ProductEan from '@/components/promotions/ProductEan'

export default {
    props: {
        data: {
            type: Object,
            required: true
        },
        promoId: {
            type: Number,
            required: true
        },
        promoType: {
            type: String,
            required: true
        }
    },
    components: {
        ProductEan
    },
    computed: {
        promotionCanceled() {
            return this.data.state === 'interrupted'
        },
        merchant() {
            return this.$store.getters.getMerchantById(this.data.merchant_id)
        },
        selectedSubscription: {
            get() {
                return this.$store.getters.getSelectedSubscription(this.data.id)
            },
            set(value) {
                this.$emit('changeAllowDeselectAll')
                this.$store.dispatch('selectSubscription', {
                    promoId: this.promoId,
                    shopId: this.data.merchant_id,
                    subscriptionId: this.data.id,
                    value
                })
                if (!value) {
                    this.$store.dispatch('setSelectAllSubscriptions', value)
                }
            }
        }
    },
    methods: {
        changePriceProduct(productId, productPrice, maxPrice, event) {
            if (this.data.state === 'available') {
                this.$store
                    .dispatch('selectSubscription', {
                        promoId: this.promoId,
                        shopId: this.data.merchant_id,
                        subscriptionId: this.data.id,
                        value: true
                    })
                    .then(() => {
                        this.$store.dispatch('setSubscriptionProductPrice', {
                            promoId: this.promoId,
                            productId: productId,
                            productPrice: productPrice,
                            merchantId: this.data.merchant_id
                        })
                    })
            }
        },
        changePriceProductSet(setId, setPrice, maxPrice, event) {
            if (this.data.state === 'available') {
                this.$store
                    .dispatch('selectSubscription', {
                        promoId: this.promoId,
                        shopId: this.data.merchant_id,
                        subscriptionId: this.data.id,
                        value: true
                    })
                    .then(() => {
                        this.$store.dispatch('setSubscriptionProductSetPrice', {
                            promoId: this.promoId,
                            setId: setId,
                            setPrice: setPrice,
                            merchantId: this.data.merchant_id
                        })
                    })
            }
        },
        goToConflictedPromo() {
            this.$router.push(`/promo-details/${this.data.conflicted_id}`)
        },
        onFocus(event) {
            setTimeout(() => {
                event.target.select()
            }, 0)
        }
    }
}
</script>
